<div>
  <angular-cropper
    *ngIf="imageUrl"
    class="cropper"
    [class.square-mode]="isSquareMode"
    #angularCropper
    [cropperOptions]="cropperOptions"
    [imageUrl]="imageUrl">
  </angular-cropper>
  <div class="button-bar" *ngIf="imageUrl">
    <div>
      <button (click)="zoomChange(-zoomStep)" [disabled]="imageLoading">
        <span class="fa fa-minus"></span>
      </button>
      <button (click)="zoomChange(zoomStep)" [disabled]="imageLoading">
        <span class="fa fa-plus"></span>
      </button>
    </div>
    <div *ngIf="allowSwitchingMode" class="mode-button-container">
      <button
        (click)="switchMode(MODES.CIRCLE)"
        ngbTooltip="Switch to circle"
        placement="bottom"
        container="body"
        *ngIf="isModeAvailable(MODES.CIRCLE)"
        [disabled]="isModeActive(MODES.CIRCLE)"
      >
        <span class="fa fa-circle-o"></span>
      </button>
      <button
        (click)="switchMode(MODES.SQUARE)"
        ngbTooltip="Switch to square"
        placement="bottom"
        container="body"
        *ngIf="isModeAvailable(MODES.SQUARE)"
        [disabled]="isModeActive(MODES.SQUARE) "
      >
        <span class="fa fa-square-o"></span>
      </button>
      <button
        (click)="switchMode(MODES.RECTANGLE)"
        ngbTooltip="Switch to rectangle"
        placement="bottom"
        container="body"
        class="rectangle-btn"
        *ngIf="isModeAvailable(MODES.RECTANGLE)"
        [disabled]="isModeActive(MODES.RECTANGLE) "
      ><span class="rectangle"></span>
      </button>
    </div>
  </div>
</div>
